module.exports = __webpack_public_path__ + "static/media/more-hovered.7abe2868.svg";